module.exports = __webpack_public_path__ + "static/media/banner.7df3283b.jpg";